import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'gatsby';

import mediaqueries from '../../styles/media';

interface TagsListProps {
  tags: string[];
}

const TagsList: React.FC<TagsListProps> = ({ tags }) => {
  return (
    <div>
      {tags.map((tag, index) => {
        return (
          <List key={index}>
            <ListItem tag={tag} index={index} />
          </List>
        );
      })}
    </div>
  );
};

export default TagsList;

function slugify(string, base) {
  const slug = string
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036F]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)+/g, '');

  return `${base}/${slug}`.replace(/\/\/+/g, '/');
}

const ListItem: React.FC<string> = ({ tag, index }) => {
  const tagPath = slugify(tag, '/tags');

  return (
    <TagLink to={tagPath} index={index}>
      <TagBox>{tag}</TagBox>
    </TagLink>
  );
};

const List = styled.div`
  display: inline-grid;
  max-width: 100%;
`;

const TagLink = styled(Link)`
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  height: 100%;
  margin: ${p => p.index % 2 === 0 ? '4px 0px' : '4px 8px'};
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  &:hover,
  &:focus {
    color: ${p => p.theme.colors.accent};
  }
`;

const TagBox = styled.div`
  color: ${p => p.theme.colors.accent};
  background-color: none;
  border-radius: 1em;
  padding: 1px 12px 3px 12px;
  display: flow-root;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border: 1px solid
    ${p => p.theme.colors.accent};

  &:hover {
    background: ${p => p.theme.colors.accent};
    color: ${p => p.theme.colors.background};
  }
`;
